<template>
  <div class="bs-example">
    <ul class="pagination">
      <li v-if="currentPage != 1"><a @click="goPage(1)"><<</a></li>
      <li v-if="currentPage != 1"><a @click="goPage(currentPage - 1)"><</a></li>
      <li v-for="p in pages" :class="p === currentPage ? 'active' : ''"><a @click="goPage(p)">{{ p }}</a></li>
      <li v-if="currentPage != totalPages"><a @click="goPage(currentPage + 1)">></a></li>
      <li v-if="currentPage != totalPages"><a @click="goPage(totalPages)">>></a></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'Pagination',
  props: ['currentPage', 'total', 'numPerPage'],
  watch: {
    total: function(val) {
      //console.log(val)
      //console.log(this.numPerPage)
      //console.log(Math.ceil(this.total / this.numPerPage))
    }
  },
  computed: {
    totalPages: function() {
      return Math.ceil(this.total / this.numPerPage)
    },
    pages: function() {
      let pageList = []
      if (this.totalPages > 7) {
        let step = this.currentPage - 4
        //console.log('totalPages='+ this.totalPages)
        //console.log('step='+ step)
        if (step < 0)
          step = 0
        pageList = Array.apply(null, { length: (this.currentPage + 3 < this.totalPages) ? 7 : (this.totalPages - this.currentPage + 4) }).map(function (v, i) {
          step ++;
          //if ()
          return step;
        })
      } else {
        let step = 0
        pageList = Array.apply(null, { length: this.totalPages }).map(function (v, i) {
          step ++;
          return step;
        })
      }
      //console.log(pageList)
      return pageList
    }
  },
  methods: {
    goPage: function(page) {
      this.currentPage = page
      this.$emit('update:currentPage', this.currentPage)
    }
  }
}
</script>
